import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import { AddCircleOutlineRounded, Delete } from "@mui/icons-material";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { IconButton, TextField } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";
import { toast } from "react-toastify";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import TextEditor from "../components/rich-text/TextEditor/TextEditor";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";
import { CACHE_KEY } from "../constant/cache-key";

export default function Footer({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [OGdata, setOGData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openAdd, setOpenAdd] = useState([]);
  const [inputV, setInputV] = useState([]);
  const [subOpenAdd, setSubOpenAdd] = useState([]);
  const [subInputV, setSubInputV] = useState([]);
  const [openSubMenuIdx, setOpenSubMenuIdx] = useState(null);
  const [itemEditible, setItemEditible] = useState({});
  const [subItemEditible, setSubItemEditible] = useState({});
  const [editibleImage, setEditibleImage] = useState();
  const [textArea, setTextArea] = useState([]);
  const [images, setImages] = useState([]);
  const subMenuRefs = useRef([]);
  const hiddenFileInput = useRef();

  const formData = new FormData();

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];

    if (file) {
      formData.append("files", file);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      }).then(async (res) => {
        const response = await res.json();
        const iconURL = response[0]?.url;

        let updatedImages = [...images];

        updatedImages[index] = { ...updatedImages[index], img: iconURL };

        fetch(`${API}/footer`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            data: { footerImg: updatedImages },
          }),
        }).then((res) => {
          if (res.ok) {
            setImages(updatedImages);
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        });
      });
    }
  };

  useEffect(() => {
    const editorElement = document.querySelector(".ql-editor");

    editorElement?.classList.add("dark-background");
  }, [langs]);

  const toggleSubMenu = (idx) => {
    setOpenSubMenuIdx(openSubMenuIdx === idx ? null : idx);
  };

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      menu: [],
      language: item.attributes.language,
    }));
    setData(docs);
    setOGData(docs);
    let testAreaDocs = langs.map((item) => ({
      textArea: "",
      mapLat: "",
      mapLong: "",
      address: "",
      hlt1: "",
      hll1: "",
      hlt2: "",
      hll2: "",
      hlt3: "",
      hll3: "",
      hlt4: "",
      hll4: "",
      language: item.attributes.language,
    }));
    setTextArea(testAreaDocs);
    let imagesDocs = langs.map((item) => ({
      img: "",
      language: item.attributes.language,
    }));
    setImages(imagesDocs);
    let errorDocs = [];
    langs.map(() => {
      errorDocs.push({ error: false });
    });
    setErrors(errorDocs);
    let openDocs = [];
    langs.map(() => {
      openDocs.push({ open: false });
    });
    setOpenAdd(openDocs);
    let subOpenDocs = [];
    langs.map(() => {
      subOpenDocs.push({ open: false });
    });
    setSubOpenAdd(subOpenDocs);
    let inputVDocs = [];
    langs.map(() => {
      inputVDocs.push({ title: "" });
    });
    setInputV(inputVDocs);
    let subInputVDocs = [];
    langs.map(() => {
      subInputVDocs.push({ title: "", url: "" });
    });
    setSubInputV(subInputVDocs);

    async function getData() {
      await fetch(`${API}/footer`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.menuData || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                menu: apiItem.menu || localItem.menu,
              };
            } else {
              return localItem;
            }
          });
        });
        setOGData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                menu: apiItem.menu || localItem.menu,
              };
            } else {
              return localItem;
            }
          });
        });

        const apiTextData = response.data?.attributes?.textArea || [];

        setTextArea((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiTextData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                textArea: apiItem.textArea || localItem.textArea,
                mapLat: apiItem.mapLat || localItem.mapLat,
                mapLong: apiItem.mapLong || localItem.mapLong,
                address: apiItem.address || localItem.address,
                hlt1: apiItem.hlt1 || localItem.hlt1,
                hll1: apiItem.hll1 || localItem.hll1,
                hlt2: apiItem.hlt2 || localItem.hlt2,
                hll2: apiItem.hll2 || localItem.hll2,
                hlt3: apiItem.hlt3 || localItem.hlt3,
                hll3: apiItem.hll3 || localItem.hll3,
                hlt4: apiItem.hlt4 || localItem.hlt4,
                hll4: apiItem.hll4 || localItem.hll4,
              };
            } else {
              return localItem;
            }
          });
        });

        const apiImgData = response.data?.attributes?.footerImg || [];

        setImages((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiImgData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                img: apiItem.img || localItem.img,
              };
            } else {
              return localItem;
            }
          });
        });
        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const handleTextAreaChange = (index, field) => (e) => {
    setTextArea((prev) =>
      prev.map((item, idx) => (idx === index ? { ...item, [field]: e.target.value } : item))
    );
  };

  const fields = [
    { label: "Text", key: "hlt1" },
    { label: "Link", key: "hll1" },
    { label: "Text", key: "hlt2" },
    { label: "Link", key: "hll2" },
    { label: "Text", key: "hlt3" },
    { label: "Link", key: "hll3" },
    { label: "Text", key: "hlt4" },
    { label: "Link", key: "hll4" },
  ];

  const submitData = (item, index) => {
    fetch(`${API}/footer`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { menuData: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  const onDragEnd = (result, index) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) return;

    const items = Array.from(data[index].menu);
    const [reorderedItem] = items.splice(source.index, 1);
    items.splice(destination.index, 0, reorderedItem);

    setData((prevData) =>
      prevData.map((item, idx) => (idx === index ? { ...item, menu: items } : item))
    );
    setOGData((prevData) =>
      prevData.map((item, idx) => (idx === index ? { ...item, menu: items } : item))
    );
  };

  const onSubDragEnd = (result, index, idx) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) return;

    // Create a copy of the nested array to work with
    const nestedMenuItems = Array.from(data[index].menu);
    const items = Array.from(nestedMenuItems[idx].dropDownItems);

    // Remove the item from the source index
    const [reorderedItem] = items.splice(source.index, 1);

    // Insert the item at the destination index
    items.splice(destination.index, 0, reorderedItem);

    // Update the nested structure in the state
    setData((prevData) =>
      prevData.map((item, i) =>
        i === index
          ? {
            ...item,
            menu: nestedMenuItems.map((nestedItem, j) =>
              j === idx ? { ...nestedItem, dropDownItems: items } : nestedItem
            ),
          }
          : item
      )
    );
    setOGData((prevData) =>
      prevData.map((item, i) =>
        i === index
          ? {
            ...item,
            menu: nestedMenuItems.map((nestedItem, j) =>
              j === idx ? { ...nestedItem, dropDownItems: items } : nestedItem
            ),
          }
          : item
      )
    );
  };

  const addNewMenuItem = (index) => {
    let tempData = data;

    tempData[index]?.menu.push({
      title: inputV[index]?.title.charAt(0).toUpperCase() + inputV[index]?.title.slice(1),

      dropDownItems: [],
    });

    fetch(`${API}/footer`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { menuData: tempData },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setData(tempData);
        setSuccess(true);
        setInputV([
          ...inputV.map((item, idx) => {
            if (idx === index) {
              return { ...item, title: "", description: "", icon: "" };
            } else {
              return item;
            }
          }),
        ]);
        setOpenAdd([
          ...openAdd.map((item, idx) => {
            if (idx === index) {
              return { ...item, open: false };
            } else {
              return item;
            }
          }),
        ]);
      } else {
        setFail(true);
      }
    });
  };

  const deleteMenuItem = (index, idx) => {
    let tempData = data;
    let filteredData = tempData[index]?.menu.filter((item, i) => i !== idx);

    tempData[index] = {
      ...tempData[index],
      menu: filteredData,
    };

    setData(tempData);

    fetch(`${API}/footer`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { menuData: tempData },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  const editMenuItem = (index, idx) => {
    setData(OGdata);
    setSubItemEditible({});

    const item = {
      index,
      idx,
    };
    setEditibleImage(null);

    if (itemEditible.index === index && itemEditible.idx === idx) {
      setItemEditible({});
    } else {
      setItemEditible(item);
    }
  };

  const editSubMenuItem = (index, idx, ndx) => {
    setData(OGdata);
    setItemEditible({});
    const item = {
      index,
      idx,
      ndx,
    };
    setEditibleImage(null);

    if (
      subItemEditible.index === index &&
      subItemEditible.idx === idx &&
      subItemEditible.ndx === ndx
    ) {
      setSubItemEditible({});
    } else {
      setSubItemEditible(item);
    }
  };

  const doneeditingMenuItem = (index, idx) => {
    const editForm = new FormData();

    if (editibleImage) {
      editForm.append("files", editibleImage);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: editForm,
      }).then(async (res) => {
        const response = await res.json();
        const iconURL = response[0]?.url;

        const updatedMenuData = [...data];

        const currentItem = updatedMenuData[index].menu[idx];

        updatedMenuData[index].menu[idx] = {
          ...currentItem,
          icon: iconURL,
        };

        fetch(`${API}/footer`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            data: { menuData: updatedMenuData },
          }),
        }).then((res) => {
          if (res.ok) {
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        });

        setData(updatedMenuData);
        setOGData(updatedMenuData);

        setItemEditible({});
      });
    } else {
      fetch(`${API}/footer`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { menuData: data },
        }),
      }).then((res) => {
        if (res.ok) {
          setOGData(data);
          toast("Updated Successfully", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "success",
          });
        }
      });
      setItemEditible({});
      setSubItemEditible({});
    }
  };
  const doneeditingMenuSubItem = (index, idx, ndx) => {
    const editForm = new FormData();

    if (editibleImage) {
      editForm.append("files", editibleImage);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: editForm,
      }).then(async (res) => {
        const response = await res.json();
        const iconURL = response[0]?.url;

        const updatedMenuData = [...data];

        const currentItem = updatedMenuData[index].menu[idx].dropDownItems[ndx];

        updatedMenuData[index].menu[idx].dropDownItems[ndx] = {
          ...currentItem,
          icon: iconURL,
        };

        fetch(`${API}/footer`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            data: { menuData: updatedMenuData },
          }),
        }).then((res) => {
          if (res.ok) {
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        });

        setData(updatedMenuData);
        setOGData(updatedMenuData);

        setSubItemEditible({});
      });
    } else {
      fetch(`${API}/footer`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { menuData: data },
        }),
      }).then((res) => {
        if (res.ok) {
          setOGData(data);
          toast("Updated Successfully", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "success",
          });
        }
      });

      setSubItemEditible({});
    }
  };

  const addNewSubMenuItem = (index, idx) => {
    let tempData = data;

    tempData[index]?.menu[idx]?.dropDownItems?.push({
      title: subInputV[index]?.title,

      url: subInputV[index]?.url,
    });

    fetch(`${API}/footer`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { menuData: tempData },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setData(tempData);
        setSuccess(true);
        setSubInputV([
          ...subInputV.map((item, idx) => {
            if (idx === index) {
              return {
                ...item,
                title: "",
                description: "",
                url: "",
                icon: "",
              };
            } else {
              return item;
            }
          }),
        ]);
        setSubOpenAdd([
          ...subOpenAdd.map((item, idx) => {
            if (idx === index) {
              return { ...item, open: false };
            } else {
              return item;
            }
          }),
        ]);
      } else {
        setFail(true);
      }
    });
  };

  const deleteSubMenuItem = (index, idx, ndx) => {
    const updatedData = [...data];

    if (
      updatedData[index] &&
      updatedData[index].menu &&
      updatedData[index].menu[idx] &&
      updatedData[index].menu[idx].dropDownItems
    ) {
      updatedData[index].menu[idx].dropDownItems = updatedData[index].menu[
        idx
      ].dropDownItems.filter((item, i) => i !== ndx);

      setData(updatedData);

      fetch(`${API}/footer`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { menuData: updatedData },
        }),
      }).then(async (res) => {
        if (res.ok) {
          setSuccess(true);
        } else {
          setFail(true);
        }
      });
    }
  };

  const submitTextArea = () => {
    fetch(`${API}/footer`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { textArea: textArea },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  return (
    <TabContext value={value}>

      <Box mt={2}>
        <ClearCacheButton
          keys={[
            CACHE_KEY.startupConfigs
          ]} />
      </Box>

      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>Footer Settings</h3>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs">
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={SERVER_DOMAIN + item.attributes.icon.data.attributes.url}
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
                  <h3>Footer Menu</h3>
                  <div>
                    <DragDropContext onDragEnd={(result) => onDragEnd(result, index)}>
                      <Droppable droppableId={`menu-${index}`} key={`droppable-${index}`}>
                        {(provided) => (
                          <ul
                            style={{ padding: 0, marginTop: 0, width: "50%" }}
                            {...provided.droppableProps}
                            ref={provided.innerRef}>
                            {data[index]?.menu.map((item, idx) => (
                              <Draggable
                                key={`item-key-${idx + 40 * 70}`}
                                draggableId={`item-key-${idx + 40 * 8}`}
                                index={idx}>
                                {(provided) => (
                                  <li
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}>
                                    <div
                                      className="menu-b-i"
                                      style={{
                                        height:
                                          itemEditible.index == index && itemEditible.idx == idx
                                            ? 100
                                            : 50,
                                      }}>
                                      <DragIndicatorIcon style={{ color: "#777" }} />

                                      <div>
                                        {itemEditible.index == index && itemEditible.idx == idx ? (
                                          <TextField
                                            variant="outlined"
                                            size="small"
                                            sx={{ mb: 1 }}
                                            inputProps={{
                                              style: { fontSize: 14 },
                                            }}
                                            value={item.title || ""}
                                            onChange={(e) =>
                                              setData(
                                                data.map((outerItem, outerIndex) => {
                                                  if (outerIndex === index) {
                                                    return {
                                                      ...outerItem,
                                                      menu: outerItem.menu.map(
                                                        (innerItem, innerIndex) => {
                                                          if (innerIndex === idx) {
                                                            return {
                                                              ...innerItem,
                                                              title: e.target.value,
                                                            };
                                                          } else {
                                                            return innerItem;
                                                          }
                                                        }
                                                      ),
                                                    };
                                                  } else {
                                                    return outerItem;
                                                  }
                                                })
                                              )
                                            }
                                          />
                                        ) : (
                                          <p
                                            style={{
                                              margin: 0,
                                              fontSize: 14,
                                              marginBottom: -3,
                                              fontWeight: "500",
                                            }}>
                                            {item.title}
                                          </p>
                                        )}
                                      </div>
                                      <div className="delete-menu-item" style={{ right: 40 }}>
                                        {itemEditible.index == index && itemEditible.idx == idx ? (
                                          <>
                                            <IconButton
                                              onClick={() => doneeditingMenuItem(index, idx)}
                                              sx={{
                                                color: "green",
                                              }}>
                                              <DoneIcon fontSize="medium" />
                                            </IconButton>
                                          </>
                                        ) : (
                                          <>
                                            {user.perms[25].edit && (
                                              <IconButton
                                                onClick={() => editMenuItem(index, idx)}
                                                sx={{
                                                  color: "grey",
                                                  "&:hover": {
                                                    color: "#0265d2",
                                                  },
                                                  transition: "0.3s",
                                                }}>
                                                <EditIcon fontSize="small" />
                                              </IconButton>
                                            )}
                                          </>
                                        )}
                                        {user.perms[25].edit && (
                                          <IconButton
                                            onClick={() => deleteMenuItem(index, idx)}
                                            sx={{
                                              color: "grey",
                                              "&:hover": {
                                                color: "red",
                                              },
                                              transition: "0.3s",
                                            }}>
                                            <Delete fontSize="small" />
                                          </IconButton>
                                        )}
                                      </div>
                                      <div className="delete-menu-item">
                                        <IconButton
                                          ref={(el) => (subMenuRefs.current[idx] = el)}
                                          onClick={() => {
                                            toggleSubMenu(idx);
                                            setSubItemEditible({});
                                          }}
                                          sx={{
                                            color: "grey",
                                            "&:hover": {
                                              color: "var(--link)",
                                            },
                                            transition: "0.3s",
                                          }}>
                                          <ArrowForwardIosIcon fontSize="small" />
                                        </IconButton>

                                        <div
                                          className="sub-menu"
                                          ref={(el) => (subMenuRefs.current[idx + 30] = el)}
                                          style={{
                                            visibility:
                                              openSubMenuIdx === idx ? "visible" : "hidden",
                                            opacity: openSubMenuIdx === idx ? 1 : 0,
                                            width: openSubMenuIdx === idx ? 430 : 0,
                                          }}>
                                          <DragDropContext
                                            onDragEnd={(result) =>
                                              onSubDragEnd(result, index, idx)
                                            }>
                                            <Droppable
                                              droppableId={`menu-${index + 60 * 8}`}
                                              key={`droppable-${index + 78 * 39}`}>
                                              {(provided) => (
                                                <ul
                                                  style={{
                                                    padding: 0,
                                                    marginTop: 0,
                                                    width: "90%",
                                                  }}
                                                  {...provided.droppableProps}
                                                  ref={provided.innerRef}>
                                                  {data[index]?.menu[idx].dropDownItems?.map(
                                                    (item, ndx) => (
                                                      <Draggable
                                                        key={`item-key-${ndx + 403 * 70}`}
                                                        draggableId={`item-key-${ndx + 4013 * 8}`}
                                                        index={ndx}>
                                                        {(provided) => (
                                                          <li
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}>
                                                            <div
                                                              className="menu-b-i"
                                                              style={{
                                                                height:
                                                                  subItemEditible.index == index &&
                                                                    subItemEditible.idx == idx &&
                                                                    subItemEditible.ndx == ndx
                                                                    ? 140
                                                                    : 50,
                                                              }}>
                                                              <DragIndicatorIcon
                                                                style={{
                                                                  color: "#777",
                                                                }}
                                                              />

                                                              <div>
                                                                {subItemEditible.index == index &&
                                                                  subItemEditible.idx == idx &&
                                                                  subItemEditible.ndx == ndx ? (
                                                                  <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    sx={{
                                                                      mb: 1,
                                                                    }}
                                                                    inputProps={{
                                                                      style: {
                                                                        fontSize: 14,
                                                                      },
                                                                    }}
                                                                    value={item.title || ""}
                                                                    onChange={(e) =>
                                                                      setData(
                                                                        data.map(
                                                                          (
                                                                            outerItem,
                                                                            outerIndex
                                                                          ) => {
                                                                            if (
                                                                              outerIndex === index
                                                                            ) {
                                                                              return {
                                                                                ...outerItem,
                                                                                menu: outerItem.menu.map(
                                                                                  (
                                                                                    innerItem,
                                                                                    innerIndex
                                                                                  ) => {
                                                                                    if (
                                                                                      innerIndex ===
                                                                                      idx
                                                                                    ) {
                                                                                      return {
                                                                                        ...innerItem,
                                                                                        dropDownItems:
                                                                                          innerItem.dropDownItems.map(
                                                                                            (
                                                                                              nestedItem,
                                                                                              nestedIndex
                                                                                            ) => {
                                                                                              if (
                                                                                                nestedIndex ===
                                                                                                ndx
                                                                                              ) {
                                                                                                return {
                                                                                                  ...nestedItem,
                                                                                                  title:
                                                                                                    e
                                                                                                      .target
                                                                                                      .value,
                                                                                                };
                                                                                              } else {
                                                                                                return nestedItem;
                                                                                              }
                                                                                            }
                                                                                          ),
                                                                                      };
                                                                                    } else {
                                                                                      return innerItem;
                                                                                    }
                                                                                  }
                                                                                ),
                                                                              };
                                                                            } else {
                                                                              return outerItem;
                                                                            }
                                                                          }
                                                                        )
                                                                      )
                                                                    }
                                                                  />
                                                                ) : (
                                                                  <p
                                                                    style={{
                                                                      margin: 0,
                                                                      fontSize: 14,
                                                                      marginBottom: -3,
                                                                      fontWeight: "500",
                                                                    }}>
                                                                    {item.title}
                                                                  </p>
                                                                )}

                                                                {subItemEditible.index == index &&
                                                                  subItemEditible.idx == idx &&
                                                                  subItemEditible.ndx == ndx && (
                                                                    <TextField
                                                                      variant="outlined"
                                                                      size="small"
                                                                      placeholder="URL"
                                                                      sx={{
                                                                        mb: 1,
                                                                      }}
                                                                      inputProps={{
                                                                        style: {
                                                                          fontSize: 14,
                                                                        },
                                                                      }}
                                                                      value={item.url || ""}
                                                                      onChange={(e) =>
                                                                        setData(
                                                                          data.map(
                                                                            (
                                                                              outerItem,
                                                                              outerIndex
                                                                            ) => {
                                                                              if (
                                                                                outerIndex === index
                                                                              ) {
                                                                                return {
                                                                                  ...outerItem,
                                                                                  menu: outerItem.menu.map(
                                                                                    (
                                                                                      innerItem,
                                                                                      innerIndex
                                                                                    ) => {
                                                                                      if (
                                                                                        innerIndex ===
                                                                                        idx
                                                                                      ) {
                                                                                        return {
                                                                                          ...innerItem,
                                                                                          dropDownItems:
                                                                                            innerItem.dropDownItems.map(
                                                                                              (
                                                                                                nestedItem,
                                                                                                nestedIndex
                                                                                              ) => {
                                                                                                if (
                                                                                                  nestedIndex ===
                                                                                                  ndx
                                                                                                ) {
                                                                                                  return {
                                                                                                    ...nestedItem,
                                                                                                    url: e
                                                                                                      .target
                                                                                                      .value,
                                                                                                  };
                                                                                                } else {
                                                                                                  return nestedItem;
                                                                                                }
                                                                                              }
                                                                                            ),
                                                                                        };
                                                                                      } else {
                                                                                        return innerItem;
                                                                                      }
                                                                                    }
                                                                                  ),
                                                                                };
                                                                              } else {
                                                                                return outerItem;
                                                                              }
                                                                            }
                                                                          )
                                                                        )
                                                                      }
                                                                    />
                                                                  )}
                                                              </div>
                                                              <div
                                                                className="delete-menu-item"
                                                                style={{
                                                                  right: 10,
                                                                }}>
                                                                {subItemEditible.index == index &&
                                                                  subItemEditible.idx == idx &&
                                                                  subItemEditible.ndx == ndx ? (
                                                                  <>
                                                                    <IconButton
                                                                      onClick={() =>
                                                                        doneeditingMenuSubItem(
                                                                          index,
                                                                          idx,
                                                                          ndx
                                                                        )
                                                                      }
                                                                      sx={{
                                                                        color: "green",
                                                                      }}>
                                                                      <DoneIcon fontSize="medium" />
                                                                    </IconButton>
                                                                  </>
                                                                ) : (
                                                                  <>
                                                                    {user.perms[25].edit && (
                                                                      <IconButton
                                                                        onClick={() =>
                                                                          editSubMenuItem(
                                                                            index,
                                                                            idx,
                                                                            ndx
                                                                          )
                                                                        }
                                                                        sx={{
                                                                          color: "grey",
                                                                          "&:hover": {
                                                                            color: "#0265d2",
                                                                          },
                                                                          transition: "0.3s",
                                                                        }}>
                                                                        <EditIcon fontSize="small" />
                                                                      </IconButton>
                                                                    )}
                                                                  </>
                                                                )}
                                                                {user.perms[25].edit && (
                                                                  <IconButton
                                                                    onClick={() =>
                                                                      deleteSubMenuItem(
                                                                        index,
                                                                        idx,
                                                                        ndx
                                                                      )
                                                                    }
                                                                    sx={{
                                                                      color: "grey",
                                                                      "&:hover": {
                                                                        color: "red",
                                                                      },
                                                                      transition: "0.3s",
                                                                    }}>
                                                                    <Delete fontSize="small" />
                                                                  </IconButton>
                                                                )}
                                                              </div>
                                                            </div>
                                                          </li>
                                                        )}
                                                      </Draggable>
                                                    )
                                                  )}
                                                  {provided.placeholder}
                                                </ul>
                                              )}
                                            </Droppable>
                                          </DragDropContext>

                                          <div
                                            style={{
                                              opacity: subOpenAdd[index]?.open ? 1 : 0,
                                              height: subOpenAdd[index]?.open ? 90 : 0,
                                              marginBottom: subOpenAdd[index]?.open ? 10 : 0,
                                              visibility: subOpenAdd[index]?.open
                                                ? "visible"
                                                : "hidden",
                                              transition: "0.3s",
                                              display: "flex",
                                              alignItems: "center",
                                              flexDirection: "column",
                                              gap: 10,
                                              width: "90%",
                                              paddingTop: 5,
                                            }}>
                                            <TextField
                                              sx={{ width: "90%" }}
                                              label="Tilte"
                                              variant="outlined"
                                              size="small"
                                              value={subInputV[index]?.title || ""}
                                              error={errors[index]?.error}
                                              onChange={(e) => {
                                                setSubInputV([
                                                  ...subInputV.map((item, idx) => {
                                                    if (idx === index) {
                                                      return {
                                                        ...item,
                                                        title: e.target.value,
                                                      };
                                                    } else {
                                                      return item;
                                                    }
                                                  }),
                                                ]);
                                              }}
                                            />

                                            <TextField
                                              sx={{ width: "90%" }}
                                              label="URL"
                                              variant="outlined"
                                              size="small"
                                              value={subInputV[index]?.url || ""}
                                              error={errors[index]?.error}
                                              onChange={(e) => {
                                                setSubInputV([
                                                  ...subInputV.map((item, idx) => {
                                                    if (idx === index) {
                                                      return {
                                                        ...item,
                                                        url: e.target.value,
                                                      };
                                                    } else {
                                                      return item;
                                                    }
                                                  }),
                                                ]);
                                              }}
                                            />
                                          </div>
                                          {user.perms[25].edit && (
                                            <div
                                              onClick={() => {
                                                if (subOpenAdd[index]?.open == false) {
                                                  setSubOpenAdd([
                                                    ...subOpenAdd.map((item, idx) => {
                                                      if (idx === index) {
                                                        return {
                                                          ...item,
                                                          open: true,
                                                        };
                                                      } else {
                                                        return item;
                                                      }
                                                    }),
                                                  ]);
                                                } else {
                                                  if (
                                                    subInputV[index]?.title !== "" &&
                                                    subInputV[index]?.url !== ""
                                                  ) {
                                                    addNewSubMenuItem(index, idx);
                                                  } else {
                                                    setSubOpenAdd([
                                                      ...subOpenAdd.map((item, idx) => {
                                                        if (idx === index) {
                                                          return {
                                                            ...item,
                                                            open: false,
                                                          };
                                                        } else {
                                                          return item;
                                                        }
                                                      }),
                                                    ]);
                                                  }
                                                }
                                              }}
                                              className="submitBTN"
                                              style={{
                                                gap: 7,
                                                fontSize: 15,
                                                height: 40,
                                                marginTop: 0,
                                                backgroundColor: subOpenAdd[index]?.open
                                                  ? subInputV[index]?.title == "" ||
                                                    subInputV[index]?.url == ""
                                                    ? "red"
                                                    : "var(--link)"
                                                  : "var(--link)",
                                              }}>
                                              {subOpenAdd[index]?.open
                                                ? subInputV[index]?.title == "" ||
                                                  subInputV[index]?.url == ""
                                                  ? "Cancel"
                                                  : "Submit"
                                                : "Add New"}
                                              {subOpenAdd[index]?.open ? (
                                                ""
                                              ) : (
                                                <AddCircleOutlineRounded style={{ fontSize: 22 }} />
                                              )}
                                            </div>
                                          )}
                                          <div
                                            style={{
                                              height: 32,
                                              width: "60%",
                                              marginTop: 2,
                                            }}
                                            className="cancelBTN"
                                            onClick={() => {
                                              setOpenSubMenuIdx(null);
                                              setSubItemEditible({});
                                            }}>
                                            Close
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </ul>
                        )}
                      </Droppable>
                    </DragDropContext>
                    <div
                      style={{
                        opacity: openAdd[index]?.open ? 1 : 0,
                        height: openAdd[index]?.open ? 40 : 0,
                        marginBottom: openAdd[index]?.open ? 10 : 0,
                        visibility: openAdd[index]?.open ? "visible" : "hidden",
                        transition: "0.3s",
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                        marginTop: 10,
                      }}>
                      <TextField
                        sx={{ width: "35%" }}
                        label="Tilte"
                        variant="outlined"
                        size="small"
                        value={inputV[index]?.title || ""}
                        error={errors[index]?.error}
                        onChange={(e) => {
                          setInputV([
                            ...inputV.map((item, idx) => {
                              if (idx === index) {
                                return { ...item, title: e.target.value };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />
                    </div>
                    {user.perms[25].edit && (
                      <div
                        className="submitBTN"
                        style={{
                          width: "35%",
                          fontSize: 15,
                          height: 40,
                          gap: 7,
                          borderRadius: 7,
                          marginTop: 15,
                          backgroundColor: openAdd[index]?.open
                            ? inputV[index]?.title == ""
                              ? "red"
                              : "var(--link)"
                            : "var(--link)",
                        }}
                        onClick={() => {
                          if (openAdd[index]?.open == false) {
                            setOpenAdd([
                              ...openAdd.map((item, idx) => {
                                if (idx === index) {
                                  return { ...item, open: true };
                                } else {
                                  return item;
                                }
                              }),
                            ]);
                          } else {
                            if (inputV[index]?.title !== "") {
                              addNewMenuItem(index);
                            } else {
                              setOpenAdd([
                                ...openAdd.map((item, idx) => {
                                  if (idx === index) {
                                    return { ...item, open: false };
                                  } else {
                                    return item;
                                  }
                                }),
                              ]);
                            }
                          }
                        }}>
                        {openAdd[index]?.open
                          ? inputV[index]?.title == ""
                            ? "Cancel"
                            : "Submit"
                          : "Add New"}
                        {openAdd[index]?.open ? (
                          ""
                        ) : (
                          <AddCircleOutlineRounded style={{ fontSize: 22 }} />
                        )}
                      </div>
                    )}
                  </div>
                  {user.perms[25].edit && (
                    <div className="submitBTN" onClick={() => submitData(item, index)}>
                      Save Changes
                    </div>
                  )}

                  {Object.keys(itemEditible).length > 0 ||
                    Object.keys(subItemEditible).length > 0 ? (
                    <div
                      className="flex items-center content-center w-[350px] h-10 bg-red-500  mt-3 text-white rounded-md cursor-pointer hover:bg-red-600"
                      onClick={() => {
                        setItemEditible({});
                        setSubItemEditible({});
                      }}>
                      Cancel Editing
                    </div>
                  ) : null}

                  {user.perms[25].edit && (
                    <div className="mt-10">
                      <h3>Footer Image</h3>

                      <div
                        className="group relative w-4/12 mt-4 rounded-[55px] overflow-hidden cursor-pointer "
                        onClick={() => hiddenFileInput.current.click()}>
                        <img
                          style={{
                            width: "100%",
                            aspectRatio: 1,
                            borderRadius: 55,
                            objectFit: "cover",
                            transition: "0.2s",
                          }}
                          src={
                            images[index]?.img
                              ? SERVER_DOMAIN + images[index]?.img
                              : require("../assets/placeholder-image.png")
                          }
                        />

                        <div className="group absolute top-0 left-0 w-full rounded-[55px] h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                          <CameraAltIcon
                            style={{ fontSize: 45 }}
                            className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                          />
                        </div>

                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          onChange={(e) => handleImageChange(e, index)}
                          ref={hiddenFileInput}
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                  )}

                  <div className="mt-10">
                    <h3>Map Location</h3>

                    <TextField
                      label="Address"
                      sx={{ mt: 2, mr: 2, width: 300 }}
                      value={textArea[index]?.address || ""}
                      onChange={(e) => {
                        setTextArea([
                          ...textArea.map((item, idx) => {
                            if (idx === index) {
                              return {
                                ...item,
                                address: e.target.value,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                    <TextField
                      label="Lat"
                      sx={{ mt: 2, mr: 2 }}
                      value={textArea[index]?.mapLat || ""}
                      onChange={(e) => {
                        setTextArea([
                          ...textArea.map((item, idx) => {
                            if (idx === index) {
                              return {
                                ...item,
                                mapLat: e.target.value,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                    <TextField
                      label="Long"
                      sx={{ mt: 2 }}
                      value={textArea[index]?.mapLong || ""}
                      onChange={(e) => {
                        setTextArea([
                          ...textArea.map((item, idx) => {
                            if (idx === index) {
                              return {
                                ...item,
                                mapLong: e.target.value,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>

                  <div className="mt-10">
                    <h3>Helpful Links</h3>

                    <div className="grid grid-cols-1 lg:grid-cols-2">
                      {fields.map((field, fieldIndex) => (
                        <div className="mt-2" key={field.key}>
                          <TextField
                            label={field.label}
                            sx={{
                              mt: 2,
                              mr: field.label === "Text" ? 2 : 0,
                              width: 300,
                            }}
                            value={textArea[index]?.[field.key] || ""}
                            onChange={handleTextAreaChange(index, field.key)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="divider"></div>

                  <div className="mt-10 ">
                    <h3>Footer Text Area</h3>

                    <TextEditor
                      value={textArea[index]?.textArea || ""}
                      onChange={(v) => {
                        setTextArea([
                          ...textArea.map((item, idx) => {
                            if (idx === index) {
                              return {
                                ...item,
                                textArea: v,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>

                  {user.perms[25].edit && (
                    <div
                      className="mt-5 bg-[#0265d2] text-white w-4/12 h-10 rounded-md flex cursor-pointer"
                      onClick={submitTextArea}>
                      Submit
                    </div>
                  )}
                </TabPanel>
              );
            })}
          </>
        )}
      </Box>
    </TabContext>
  );
}
